import { Link } from '@solidjs/router';
import { For, Show } from 'solid-js';
import clsx from 'clsx';
import type { MenuItem, SubLevelMenuProps } from '../../../menu-types';
import { removeTrailingSlash } from '../../../../../tools/remove-trailing-slash';
import removeAmpersand from '../../../../../tools/remove-ampersand';
import urlMatches from '../../../../../tools/url-match';
import { isExternalLink } from '../../../../../tools/check-is-external-url';
import { ArrowRightIcon } from '../../../../icons-library/arrow-right';
import { Section } from '../../../../../grid-system/section/section';

export const SubLevelMenu = (props: SubLevelMenuProps) => {
    const parentHasUrl = () => Boolean(props.parent.url);

    return (
        <div class="flex flex-col">
            <div class="bg-cvi-bg-menu-active">
                <Section
                    templateShorthand={[12]}
                    widthType="bgFull"
                    removeSpacingBlock={true}
                >
                    <Show
                        when={parentHasUrl()}
                        fallback={
                            <div class="flex items-center min-h-cvi-touch-min p-cvi-4 label-lg font-cvi-medium text-cvi-fg-default">
                                {removeAmpersand(props.parent.title)}
                            </div>
                        }
                    >
                        <Link
                            href={removeTrailingSlash(props.parent.url)}
                            onClick={() => props.onLinkClick()}
                            class="flex items-center justify-between gap-cvi-8 min-h-cvi-touch-min p-cvi-4 label-lg font-cvi-medium text-cvi-fg-link no-underline transition-colors duration-200 hover:text-cvi-fg-link"
                            {...(isExternalLink(props.parent.url)
                                ? {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                }
                                : {})}
                        >
                            <span class="min-w-0">{removeAmpersand(props.parent.title)}</span>
                            <span class="inline-flex items-center shrink-0">
                                <ArrowRightIcon fill="currentColor" />
                            </span>
                        </Link>
                    </Show>
                </Section>
            </div>

            <Section
                templateShorthand={[12]}
                widthType="bgFull"
                removeSpacingBlock={true}
                customCss="padding-top: 0 !important; padding-bottom: 0 !important;"
            >
                <ul class="flex flex-col pt-cvi-6">
                    <For each={props.parent.children}>
                        {(child: MenuItem) => {
                            const isActive = () => urlMatches(child.url);
                            return (
                                <li>
                                    <Link
                                        href={removeTrailingSlash(child.url)}
                                        onClick={() => props.onLinkClick()}
                                        class={clsx(
                                            'flex items-center gap-cvi-5 min-h-cvi-touch-min p-cvi-4 label-lg text-cvi-fg-default no-underline transition-colors duration-200 hover:text-cvi-fg-link',
                                            isActive() ? 'font-cvi-bold' : 'font-cvi-medium'
                                        )}
                                        {...(isExternalLink(child.url)
                                            ? {
                                                target: '_blank',
                                                rel: 'noopener noreferrer',
                                            }
                                            : {})}
                                    >
                                        <Show when={isActive()}>
                                            <span
                                                aria-hidden="true"
                                                class="size-cvi-3 rounded-cvi-round bg-cvi-fg-brand shrink-0 self-start mt-cvi-4"
                                            />
                                        </Show>
                                        {removeAmpersand(child.title)}
                                    </Link>
                                </li>
                            );
                        }}
                    </For>
                </ul>
            </Section>
        </div>
    );
};
